import React from 'react';
import { Box, BoxProps, Icon } from '@chakra-ui/react';

export const MediumIcon = (props: BoxProps) => {
  //
  return (
    <Box {...props}>
      <Icon
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
        display="block"
      >
        <path
          d="M11.2812 10C11.2812 13.1063 8.75625 15.625 5.64 15.625C4.90033 15.626 4.16771 15.4813 3.48396 15.1991C2.80022 14.917 2.17875 14.5029 1.65502 13.9806C1.1313 13.4583 0.715587 12.8379 0.431617 12.1549C0.147648 11.4719 0.000984258 10.7397 0 10C0 6.89251 2.525 4.37501 5.64 4.37501C6.37978 4.37386 7.11253 4.51845 7.79642 4.80052C8.48031 5.0826 9.10193 5.49663 9.62579 6.01898C10.1496 6.54133 10.5655 7.16175 10.8495 7.84482C11.1336 8.52789 11.2803 9.26023 11.2812 10ZM17.4688 10C17.4688 12.925 16.2062 15.295 14.6488 15.295C13.0912 15.295 11.8288 12.9238 11.8288 10C11.8288 7.07501 13.0912 4.70501 14.6488 4.70501C16.2062 4.70501 17.4688 7.07626 17.4688 10ZM20 10C20 12.62 19.5562 14.7438 19.0075 14.7438C18.46 14.7438 18.0163 12.6188 18.0163 10C18.0163 7.38001 18.46 5.25626 19.0087 5.25626C19.5562 5.25626 20 7.38001 20 10Z"
          fill="currentColor"
        />
      </Icon>
    </Box>
  );
};
